import {
  PROBE_FINAL_DELAY_MS,
  PROBE_JITTER_RATIO,
  PROBE_SCHEDULE_MS,
} from '../constants/apiReachabilityConstants';

export const getProbeDelayMs = (attemptIndex, random = Math.random) => {
  const baseDelay = PROBE_SCHEDULE_MS[attemptIndex] ?? PROBE_FINAL_DELAY_MS;
  const jitterSpan = PROBE_JITTER_RATIO * 2;

  return baseDelay * (1 - PROBE_JITTER_RATIO + random() * jitterSpan);
};
